import React from 'react'
import Icon from 'decorators/Icon'

const IconMapDragPin = ({ t, className }) => (
  <svg className={className} width={27} height={40}>
    <title>{t('Map Drag Pin')}</title>
    <g fill='none' fillRule='evenodd'>
      <path
        fill='#E5331F'
        d='M26.412 13.261c0 7.294-13.206 26.725-13.206 26.725S0 20.555 0 13.261C0 5.968 5.912.055 13.206.055c7.293 0 13.206 5.913 13.206 13.206'
      />
      <path
        fill='#6F2F2A'
        d='M17.938 13.815a4.732 4.732 0 1 1-9.465 0 4.732 4.732 0 0 1 9.465 0'
      />
    </g>
  </svg>
)

export default Icon(IconMapDragPin)
